import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useWizard } from 'react-use-wizard';
import { formatAmount2 } from '../../../../lib/utils/utilitarios';
import { faTimes, faInfo } from '@fortawesome/free-solid-svg-icons';
import { getBank, onChangeActivarOtros } from '../../../../redux/reducers/productCatalogsSlice';
import { addRefundInformation } from '../../../../redux/reducers/refundInformationSlice';
import ButtonComponent from '../../../../components/button/button_component';
import DropDownComponent from './../../../../components/dropdown/dropdown_component';
import DropDownBankComponent from './../../../../components/dropdownBank/dropdownBank_component';
import InputTextComponent from './../../../../components/inputText/inputText_component';
import NotificationComponent from '../../../../components/notification/notification_component';
import HeaderWizardComponent from './../../../../components/headerWizard/headerWizard_component';
import imagen_tranferencias from '../../../../assets/images/img_transferencia.png';
import cn from '../../../../lib/bem';

import './infoDevForm.scss';

const InfoDevForm = ({ titulo, descripcion, nombreMonto }) => {
    
    const classes  = cn("infoDevForm");
    const dispatch = useDispatch();

    const productCatalog    = useSelector((state) => state.rootReducers.productCatalog);
    const endosoPoliza      = useSelector((state) => state.rootReducers.endosoPoliza);
    const userinfo          = JSON.parse(sessionStorage.getItem("infoUsuario"));

    const { activeStep, stepCount, nextStep } = useWizard();
    const [ nombreAsegurado, guardarNombreAsegurado ] = useState(`${userinfo.nombre} ${userinfo.apepat} ${userinfo.apemat}`);
    const [ nombreAseguradoMsg, guardarNombreAseguradoMsg ] = useState('');
    const [ codigoBanco, guardarCodigoBanco ] = useState('');
    const [ codigoBancoMsg, guardarCodigoBancoMsg ] = useState('');
    const [ tipoCuenta, guardarTipoCuenta ] = useState('');
    const [ tipoCuentaMsg, guardarTipoCuentaMsg ] = useState('');
    const [ monedaCuenta, guardarMonedaCuenta ] = useState(endosoPoliza.datosPoliza?.descripcionMoneda);
    const [ monedaCuentaMsg, guardarMonedaCuentaMsg ] = useState('');
    const [ numeroCuenta, guardarNumeroCuenta ] = useState('');
    const [ numeroCuentaMsg, guardarNumeroCuentaMsg ] = useState('');
    const [ mostrarImagen, guardarMostrarImagen ] = useState(false);

    const [ activarOtrosBancos, guardarActivarOtrosBancos] = useState(productCatalog.activarOtros);

    const [ documentocci, setDocumentocci ] = useState('');
    const [ documentoNombrecci, setDocumentoNombrecci ] = useState('');
    const [ documentocciMsg, setDocumentocciMsg ] = useState('');

    const validarCargaDocumento = e => {

        let reader  = new FileReader();
        let file    = e.target.files[0];
        let size    = file.size;

        reader.readAsDataURL(file);

        if(size <= 5000000){
            reader.onloadend = () => {
                setDocumentocci(reader.result.toString().replace(/^data:(.*,)?/, ''));
                setDocumentoNombrecci(file.name);
                setDocumentocciMsg('');
            }
        } else {
            setDocumentocci('');
            setDocumentoNombrecci('');
            setDocumentocciMsg('Tamaño de la imagen excede el límite.')
        }

    }

    const submitGuardarInformacionDevolucion = () => {

        if( numeroCuenta.trim() === '' ){
            guardarNumeroCuentaMsg('Completar campo');
            return;
        }

        if( !activarOtrosBancos && numeroCuenta.length < 10 || numeroCuenta.length > 20){
            guardarNumeroCuentaMsg('Completar campo correctamente');
            return;
        }

        if( activarOtrosBancos && numeroCuenta.length !== 20){
            guardarNumeroCuentaMsg('Recuerda que las cuentas CCI debe tener 20 dígitos');
            return;
        }

        if( activarOtrosBancos && documentocci === ''){
            setDocumentocciMsg('Completar campo correctamente');
            return;
        }

        dispatch(addRefundInformation({
            'nombreAsegurado'   : nombreAsegurado,
            'codigoBanco'       : codigoBanco,
            'tipoCuenta'        : tipoCuenta,
            'monedaCuenta'      : monedaCuenta,
            'numeroCuenta'      : numeroCuenta,
            'nombreDocCCI'      : activarOtrosBancos ? documentoNombrecci : '',
            'archivoDocCCI'     : activarOtrosBancos ? documentocci : ''
        }));

        dispatch(getBank(codigoBanco));
        dispatch(onChangeActivarOtros(activarOtrosBancos));
        nextStep();
    }

    const activarBtnGuardar = nombreAsegurado.trim() === '' ||  codigoBanco.trim() === '' ||  tipoCuenta.trim() === '' || monedaCuenta.trim() === '' || numeroCuenta.trim() === '' ? true : false;
    const validarError = endosoPoliza.error !== "" ? endosoPoliza.error : productCatalog.error;

    return (
        <div>
            <HeaderWizardComponent stepNro={activeStep} stepMax={stepCount} title={"Asegurado"}/>

            {
                !mostrarImagen ?
                    <div className={classes()}>

                        {
                            activarOtrosBancos && numeroCuentaMsg !== '' || documentocciMsg !== '' ?
                                <div className={classes('descrDiv')} >
                                    <NotificationComponent faIcon={faInfo} textNotification={
                                        <>Para validar el reembolso, es obligatorio que adjuntes <b>todos</b> los documentos en el listado</>
                                    } tipo="information"/>
                                    <br/>
                                </div> : null
                        }

                        <p className={classes('titleInfoDev')}><b>{titulo}</b></p>
                        <p className={classes('descrInfoDev')}>{descripcion}</p>

                        {
                            activarOtrosBancos ? 
                                <p className={classes('descrInfoDev')}>Ten presente, que al ser una transferencia via CCI podr&iacute;an aplicarse comisiones seg&uacute;n el banco que reciba la transferencia del monto de rescate. </p> : null
                        }

                        {
                            endosoPoliza.error !== "" || productCatalog.error !== ""? 
                                <div>
                                    <br/>
                                    <NotificationComponent faIcon={faTimes} textNotification={validarError} tipo="error"/>
                                    <br/>
                                </div>
                            :   <div>
                                    <div className={classes('divMonto')}>
                                        <p className={classes('descrInfoDev')}>{nombreMonto}</p>
                                        <p className={classes('descrMontDev')}>{endosoPoliza.datosPoliza?.simboloMoneda} <span>{ formatAmount2(endosoPoliza.datosPoliza?.montoEndoso + '')}</span></p>
                                    </div>

                                    <InputTextComponent 
                                        name={'txtNombreAsegurado'}
                                        placeholder={'Nombre del asegurado'}
                                        value={nombreAsegurado}
                                        accion={guardarNombreAsegurado}
                                        msgValidador={nombreAseguradoMsg}
                                        focus={() => guardarNombreAseguradoMsg('')}
                                        disabled={true}
                                        tipoCampo={'text'}
                                        maxLength={100}
                                    />
                                    
                                    <DropDownBankComponent 
                                        label="dropBanco"
                                        placeholder={'Nombre del banco'} 
                                        listDropDown={productCatalog.bancos}
                                        value={codigoBanco}
                                        accion={guardarCodigoBanco}
                                        msgValidador={codigoBancoMsg}
                                        focus={() => guardarCodigoBancoMsg('')}
                                        activeOther={activarOtrosBancos}
                                        accionActiveOther={() => guardarActivarOtrosBancos(!activarOtrosBancos)}
                                    />

                                    <DropDownComponent 
                                        label="dropTipoCuenta"
                                        placeholder={'Tipo de cuenta'} 
                                        listDropDown={productCatalog.tiposCuenta}
                                        value={tipoCuenta}
                                        accion={guardarTipoCuenta}
                                        msgValidador={tipoCuentaMsg}
                                        focus={() => guardarTipoCuentaMsg('')}
                                    />

                                    <InputTextComponent
                                        name={'txtMonedaCuenta'}
                                        placeholder={'Moneda de la cuenta'}
                                        value={monedaCuenta}
                                        accion={guardarMonedaCuenta}
                                        msgValidador={monedaCuentaMsg}
                                        focus={() => guardarMonedaCuentaMsg('')}
                                        disabled={true}
                                        tipoCampo={'text'}
                                        maxLength={20}
                                    />

                                    <InputTextComponent 
                                        name={'txtNumeroCuenta'}
                                        placeholder={'Número de cuenta'}
                                        value={numeroCuenta}
                                        accion={guardarNumeroCuenta}
                                        msgValidador={numeroCuentaMsg}
                                        focus={() => guardarNumeroCuentaMsg('')}
                                        disabled={false}
                                        tipoCampo={'numeric'}
                                        maxLength={20}
                                    />

                                    {
                                        activarOtrosBancos ? 
                                            <div> 
                                                <br/>
                                                <p className={classes('titleInfoDev')}>Adjunta la foto de la cuenta con el nombre del titular</p>
                                                <p className={classes('descrInfoDevCCI')}>Si tu cuenta pertenece a otro banco, adjunta una foto o captura de la cuenta con el nombre del titular. <b>Importante: La foto debe estar n&iacute;tida para que el proceso sea v&aacute;lido.</b> Puedes ver una referencia de la foto a adjuntar, <a onClick={() => guardarMostrarImagen(true)} >aqu&iacute;</a> </p>
                                                <br/>
                                                <div className={classes('inputFileCCIDiv')}>
                                                    <br/>
                                                    <div className={classes('inputFileCCI')}>
                                                        <input type="file" name="src-file1" aria-label="Archivo" onChange={validarCargaDocumento}  multiple accept=".png, .jpg, .jpeg, .pdf"/>
                                                    </div>
                                                    
                                                    {
                                                        documentocciMsg !== '' ?
                                                            <p className={classes('descrInfoDevCCILabelError')}>{documentocciMsg}</p>
                                                        :
                                                            <p className={classes('descrInfoDevCCILabel1')}><b>{documentoNombrecci}</b></p>
                                                    }
                                                    <p className={classes('descrInfoDevCCILabel')}>Los formatos permitidos son jpg, png y pdf</p>
                                                    <p className={classes('descrInfoDevCCILabel')}>(Máximo 5 MB)</p>
                                                </div>
                                            </div> : null 
                                    
                                    }

                                    <div className={classes('buttonGuardar')}>
                                        <ButtonComponent label={'btnGuardar'} nombre={'Guardar'} tipo={'button-red'} action={() => submitGuardarInformacionDevolucion()} disabled={activarBtnGuardar}/>
                                    </div>
                                </div>
                        }
                    </div>
                : 
                    <div className={classes()}>
                        <img src={imagen_tranferencias} alt='Imagen'/>

                        <div className={classes('buttonGuardar')}>
                            <ButtonComponent label={'btnVolver'} nombre={'Volver'} tipo={'button-red'} action={() => guardarMostrarImagen(false)} disabled={false}/>
                        </div>
                    </div>    
            }
            
        </div>
    );
};

export default InfoDevForm;
